import { Check, Copy, Download } from "lucide-react";
import { Button } from "@tremor/react";
import { useState, useEffect, useRef } from "react";
import clsx from "clsx";
export interface WorkflowYAMLEditorToolbarProps {
  onCopy: () => Promise<void>;
  onDownload: () => void;
  onSave?: () => void;
  isEditorMounted: boolean;
  readOnly?: boolean;
  className?: string;
}
export function WorkflowYAMLEditorToolbar({
  onCopy,
  onDownload,
  onSave,
  isEditorMounted,
  readOnly = false,
  className
}: WorkflowYAMLEditorToolbarProps) {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  const handleCopy = async () => {
    try {
      await onCopy();
      setIsCopied(true);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };
  return <div className={clsx("absolute top-2 right-6 z-10 flex gap-2", className)} data-sentry-component="WorkflowYAMLEditorToolbar" data-sentry-source-file="WorkflowYAMLEditorToolbar.tsx">
      <Button color="orange" size="sm" className="h-8 px-2 bg-white" onClick={handleCopy} variant="secondary" data-testid="copy-yaml-button" disabled={!isEditorMounted} data-sentry-element="Button" data-sentry-source-file="WorkflowYAMLEditorToolbar.tsx">
        {isCopied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      </Button>
      <Button color="orange" size="sm" className="h-8 px-2 bg-white" onClick={onDownload} variant="secondary" data-testid="download-yaml-button" disabled={!isEditorMounted} data-sentry-element="Button" data-sentry-source-file="WorkflowYAMLEditorToolbar.tsx">
        <Download className="h-4 w-4" data-sentry-element="Download" data-sentry-source-file="WorkflowYAMLEditorToolbar.tsx" />
      </Button>
      {!readOnly && onSave ? <Button color="orange" size="sm" className="h-8 px-2" onClick={onSave} variant="primary" data-testid="save-yaml-button">
          Save
        </Button> : null}
    </div>;
}